import { ReactComponent as CopyIcon } from "../../assets/icons/copy.icon.svg";

const DEFAULT_CLASSNAMES = {
  button:
    "group shadow active:skew-y-0 hover:skew-y-3 shadow-secondary font-ubuntuBold rounded-full px-2 py-2 bg-primary text-white hover:bg-secondary",
  icon: "fill-white",
};

const CopyButton = ({ handleClick, classNames = DEFAULT_CLASSNAMES }) => {
  return (
    <button
      onClick={handleClick}
      className={classNames?.button || DEFAULT_CLASSNAMES.button}
    >
      <CopyIcon className={classNames?.icon || DEFAULT_CLASSNAMES.icon} />
    </button>
  );
};

export default CopyButton;
